export const mensData = [
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1918887199.jpg?size=400x400",
    title:
      "Dr. Seuss The Grinch Who Stole Christmas Matching Family Pajama Sets ",
    price: 49.98,
    type: "pajama",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/270000/279100/279185/products/1795166995.jpg?size=400x400",
    title: 'Rocky 11 " GORE-TEX® Waterproof Socks',
    price: 21.96,
    type: "misc",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908032855.jpg?size=400x400",
    title: "Gray and White Puppy Dog Ankle Socks (Adult Medium) ",
    price: 15.34,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908033061.jpg?size=400x400",
    title: "Dignified Reflective Panda Wearing a Suit Socks (Adult Large) ",
    price: 17.76,
    type: "socks",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1874378655.jpg?size=400x400",
    title: "Grunt Style Fisherman Defined T-Shirt - Black ",
    price: 41.69,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1870463208.jpg?size=400x400",
    title: "Grunt Style Whiskey Helps T-Shirt - Light Gray ",
    price: 4.57,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908032772.jpg?size=400x400",
    title: "Camouflage Panda Socks from the Sock Panda (Adult Large) ",
    price: 18.52,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1786407846.jpg?size=400x400",
    title: "Grunt Style Get Bent T-Shirt - Black ",
    price: 37.44,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908033245.jpg?size=400x400",
    title: "Fox Guarding the Henhouse Socks - Sock Panda ",
    price: 33.82,
    type: "socks",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1865547880.jpg?size=400x400",
    title:
      "Grunt Style Realtree AP Blaze - Hunt. Drink. Fish. T-Shirt - Black ",
    price: 5.56,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907394239.jpg?size=400x400",
    title: "Elevate Mens Elbert Pique T-Shirt ",
    price: 45.39,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907384845.jpg?size=400x400",
    title: "Marvel Unisex Adults Venom Carnage Is Back Design T-shirt ",
    price: 20.55,
    type: "misc",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907391135.jpg?size=400x400",
    title:
      "Mens 100% Cotton Ribbed /Rib Classic Casual Crew Socks (Pack Of 6) US Size 7-12 ",
    price: 15.91,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/270000/273200/273200/products/1891851307.jpg?size=400x400",
    title: "Van Heusen Mens The Girbaran Printed Office Neck Tie ",
    price: 26.05,
    type: "tie",
    cashBack: 1,
    percentCashBack: 0,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1875915956.jpg?size=400x400",
    title: "Grunt Style Spartan Prepared T-Shirt - Black ",
    price: 4.71,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/240000/243400/243406/products/1720064871.jpg?size=400x400",
    title: "Tommy Hilfiger Men's Quilted Puffer Jacket, Created for Macy's ",
    price: 37.64,
    type: "jacket",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/240000/243400/243406/products/1910174391.jpg?size=400x400",
    title: "Calvin Klein Men's Logo Slim Fit Com Promo Dress Shirt ",
    price: 5.4,
    type: "shirt",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/270000/278100/278132/products/1914730509.jpg?size=400x400",
    title:
      "Sun + Stone Mens Gray Camouflage Long Sleeve Oversized Fit Draw String Thermal Hoodie ",
    price: 45.4,
    type: "hoodie",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1907210176.jpg?size=400x400",
    title: "Rolling Rock Green Hoodie ",
    price: 45.48,
    type: "hoodie",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907375574.jpg?size=400x400",
    title: "Yoko Mens Hi Vis Reflective Hoodie ",
    price: 11.37,
    type: "hoodie",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1822389742.jpg?size=400x400",
    title: "Grunt Style Dad Defined Pullover Hoodie - Black ",
    price: 14.97,
    type: "hoodie",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1586371075.jpg?size=400x400",
    title: "Natural Light Grey Beer Pouch Hoodie ",
    price: 28.36,
    type: "hoodie",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1913420340.jpg?size=400x400",
    title: "Crazy Boxers Cheez-It All Over Boxer Briefs Cracker Box ",
    price: 1.66,
    type: "brief",
    cashBack: 1,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1833978373.jpg?size=400x400",
    title: "Grunt Style Bacon Flag T-Shirt - Black ",
    price: 29.51,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1915249140.jpg?size=400x400",
    title:
      "National Lampoon's Christmas Vacation Hap Hap Happiest Christmas Adult T-Shirt ",
    price: 19.58,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/240000/248200/248295/products/1897475301.jpg?size=400x400",
    title: "Nike Sportswear Swoosh Hoodie ",
    price: 37.54,
    type: "hoodie",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1865547882.jpg?size=400x400",
    title: "Grunt Style Realtree Edge - Beer Season T-Shirt - Black ",
    price: 10.34,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1913128388.jpg?size=400x400",
    title:
      "The Simpsons Mens' Christmas Homer Duff Beer and Holly Sleep Pajama Pants ",
    price: 42.69,
    type: "pajama",
    cashBack: 2,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907421591.jpg?size=400x400",
    title: "Tom Franks Mens Striped Flannel Pajama Set ",
    price: 12.06,
    type: "pajama",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1918887200.jpg?size=400x400",
    title:
      "Dr. Seuss The Grinch Who Stole Christmas Matching Family Pajama Sets ",
    price: 11.19,
    type: "pajama",
    cashBack: 1,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1903738593.jpg?size=400x400",
    title:
      "Star Wars The Mandalorian The Child Mens' Lounge Sleep Pajama Pants ",
    price: 28.11,
    type: "pajama",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1902380931.jpg?size=400x400",
    title:
      "Star Wars The Mandalorian Baby Yoda Men's Power Nap Sleep Pajama Pants ",
    price: 42.18,
    type: "pajama",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908032880.jpg?size=400x400",
    title: "Fantastic Panda Pattern Socks (Adult Large) ",
    price: 8.56,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907402453.jpg?size=400x400",
    title:
      "Mens Days Of The Week Boxer Briefs/Shorts/Trunks Underwear (Pack Of 7) Szs S-XL ",
    price: 8.49,
    type: "brief",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/270000/273200/273200/products/1918442822.jpg?size=400x400",
    title: "33 Degrees Mens Dapper Dude Holiday Ugly Christmas Sweater ",
    price: 9.67,
    type: "misc",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/270000/273200/273200/products/1919804496.jpg?size=400x400",
    title: "Layer 8 Mens 4 Pack Performance Boxer Briefs ",
    price: 39.65,
    type: "brief",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1893284830.jpg?size=400x400",
    title: "Pale Ale Beer Swag Boxer Briefs in a Can ",
    price: 21.84,
    type: "brief",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907421176.jpg?size=400x400",
    title:
      "FLOSO Mens Thermal Leggings Underwear Long Johns/Pants (Standard Range) ",
    price: 3.21,
    type: "misc",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1865742326.jpg?size=400x400",
    title: "Grunt Style Alcohol Sanitizes T-Shirt - Heather Gray ",
    price: 30.12,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1850586579.jpg?size=400x400",
    title: "Froot Loops Fruit Cereal Boxer Briefs ",
    price: 25.75,
    type: "brief",
    cashBack: 1,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/280000/280600/280604/products/1888911972.jpg?size=400x400",
    title:
      "Boot Doctor Men's Full Cushioned Over The Calf Boot Socks (2 Pair Pack) ",
    price: 34.79,
    type: "socks",
    cashBack: 1,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1919806015.jpg?size=400x400",
    title:
      "Vibrant Turquoise and Yellow Patterned Sock from the Sock Panda (Adult Large) ",
    price: 9.3,
    type: "misc",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/270000/278100/278132/products/1921848274.jpg?size=400x400",
    title: "INC Mens Burgundy Full Zip Sweater ",
    price: 24.06,
    type: "misc",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1913063508.jpg?size=400x400",
    title:
      "Sesame Street Men's Cookie Monster Tie Dye Adult Sleep Lounge Pajama Pants ",
    price: 29.39,
    type: "pajama",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1895631394.jpg?size=400x400",
    title: "Street Fighter Select Your Fighter Men's ODD Boxer Briefs ",
    price: 46.19,
    type: "brief",
    cashBack: 2,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/240000/249500/249510/products/1575654574.jpg?size=400x400",
    title: "Men's Thermal Crew Neck Top & Bottoms Long Johns Underwear Set ",
    price: 33.22,
    type: "misc",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/280000/289600/289605/products/1919125395.jpg?size=400x400",
    title:
      "Tasso Elba Men's Sport Coat Gray Size XL Two-Button Notched Lapel Linen ",
    price: 41.13,
    type: "misc",
    cashBack: 2,
    percentCashBack: 3,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289943/products/1907414574.jpg?size=400x400",
    title:
      "Fruit Of The Loom Mens Cotton Classic Slip Briefs /Pants Underwear (Pack Of 3) ",
    price: 42.03,
    type: "brief",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908033115.jpg?size=400x400",
    title: "Blue with Black Polka Dots Socks ",
    price: 16.94,
    type: "socks",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1891326747.jpg?size=400x400",
    title: "Friends Men's TV Series NYC Skyline With Logo Graphic T-Shirt ",
    price: 11.81,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 0,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1792110551.jpg?size=400x400",
    title: "Busch Light Logo Men's Navy Blue T-Shirt ",
    price: 15.47,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1810722035.jpg?size=400x400",
    title:
      "WB Looney Tunes Character Faces Men's 5 Pair Casual Crew Socks Mid Calf ",
    price: 45.4,
    type: "socks",
    cashBack: 2,
    percentCashBack: 4,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1810722063.jpg?size=400x400",
    title: "Nintendo Pac-Man Maze Arcade 2 Pack Crew Socks ",
    price: 7.62,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/250000/254500/254570/products/1891099806.jpg?size=400x400",
    title: "Aggretsuko Men's Japanese Musical Comedy Anime Rage Panda T-shirt ",
    price: 33.29,
    type: "misc",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1908032797.jpg?size=400x400",
    title: "Stylish Blue Rectangle Diamond Socks ",
    price: 30.72,
    type: "socks",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/260000/269300/269358/products/1887211649.jpg?size=400x400",
    title: "Busch Light Brewed for Fishing Blue Colorway T-Shirt ",
    price: 45.85,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/280000/289900/289927/products/1919805782.jpg?size=400x400",
    title:
      "Christmas Border Collie Socks (Adult Medium) - Gray or Green - Gray / Medium ",
    price: 37.04,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/240000/249300/249385/products/1795491803.jpg?size=400x400",
    title: "Grunt Style Dad Defined T-Shirt - Black/White ",
    price: 38.25,
    type: "tShirt",
    cashBack: 1,
    percentCashBack: 2,
  },
  {
    link: "https://img.shop.com/Image/250000/259100/259190/products/1914727212.jpg?size=400x400",
    title: "Star Wars Mens 12 Days of Socks in Advent Gift Box ",
    price: 7.77,
    type: "socks",
    cashBack: 1,
    percentCashBack: 1,
  },
  {
    link: "https://img.shop.com/Image/250000/259100/259190/products/1741570436.jpg?size=400x400",
    title: "Cuphead Collectibles | Cuphead Bang Bang Socks | Men's Crew Socks ",
    price: 39.91,
    type: "socks",
    cashBack: 1,
    percentCashBack: 2,
  },
];

localStorage.setItem("menData", JSON.stringify(mensData));
